import { useEffect, useState } from 'react';

/**
 * Tracks `prefers-reduced-motion`. Drives the question screen's auto-advance:
 * when reduced motion is requested the confirm sweep does not animate and the
 * visitor continues manually (handoff §Interactions).
 */
export function usePrefersReducedMotion(): boolean {
  const [prefers, setPrefers] = useState(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  );

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (event: MediaQueryListEvent) => setPrefers(event.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return prefers;
}
